<template>
  <div class="m-general-settings">
    <div class="m-general-settings__title">
      Авторизация
    </div>
    <div class="m-general-settings__content">
      <el-form-item label="Кол-во одновременно залогинненых устройств">
        <el-input v-model="state.maxUserDevicesCount.value" />
      </el-form-item>
    </div>
    <div class="m-general-settings__title">
      Посты
    </div>
    <div class="m-general-settings__content">
      <el-form label-position="right">
        <el-form-item class="checkbox" label="Включить возможность запиненых постов">
          <el-checkbox v-model="state.postPinEnabled.value" />
        </el-form-item>
      </el-form>
    </div>
    <div v-if="analytics">
      <div class="m-general-settings__title">
        Аналитика
      </div>
      <div class="m-general-settings__content">
        <el-form label-position="right">
          <el-form-item class="checkbox" label="Включить аналитику">
            <el-checkbox v-model="state.analyticCollectorEnabled.value" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <template v-if="state.showManagerLink?.code">
      <div class="m-general-settings__title">
        Ссылка на менеджера
        <el-tooltip
          class="box-item"
          content="Эта ссылка будет отображена у всех пользователей после неуспешной авторизации"
          placement="top"
          show-after="100"
        >
          <el-icon size="15" class="icon">
            <component :is="Question" />
          </el-icon>
        </el-tooltip>
      </div>
      <div class="m-general-settings__content">
        <el-form label-position="right">
          <el-form-item class="checkbox" label="Показывать ссылку">
            <el-checkbox v-model="state.showManagerLink.value" />
          </el-form-item>

          <el-form-item label="Ссылка на менеджера">
            <el-input v-model="state.managerLink.value" />
          </el-form-item>
        </el-form>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import Question from 'features/settings/mobile-editor/assets/icons/question.svg';

export default defineComponent({
  name: 'MGeneralSettings',
  props: {
    data: {
      type: Object,
      default: null,
    },
    analytics: {
      type: Boolean,
      default: false,
    },
    managerPreference: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {
    const state = ref(props.data);

    return {
      state,
      Question,
    };
  },
});
</script>

<style lang="scss" scoped>
.m-general-settings {
  &__title {
    font-size: var(--el-font-size-large);
  }
  &__content {
    margin-top: 20px;
    & .checkbox {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-direction: row-reverse;
      width: max-content;
    }
  }
}
</style>
